import { useFlags } from "launchdarkly-react-client-sdk";
import { AI_CONFIDENCE_PAGE_FLAG_KEY } from "@src/config/launchDarkly";

export const useAiConfidencePageEnabled = (): boolean => {
	const flags = useFlags<Record<string, boolean | undefined>>();

	return flags[AI_CONFIDENCE_PAGE_FLAG_KEY] === true;
};
